<template>
  <div class="edit_form">
    <div style="margin-bottom: 15px;">
      <nav-bar />
    </div>
    <div class="upload_file">
      <van-uploader
        class="upload_img"
        preview-size="100vw"
        :after-read="afterRead"
      />
      <edit-list left="头像" right="jpg">
        <img
          class="user_img"
          slot="right"
          v-if="model.headimg"
          :src="model.headimg"
          alt
        />
        <img
          class="user_img"
          slot="right"
          v-else
          src="../assets/akari.png"
          alt
        />
      </edit-list>
    </div>

    <edit-list left="昵称" @listClick="show = true" right>
      <a href="javascript:;" slot="right">{{ model.nickname }}</a>
    </edit-list>

    <edit-list left="性别" @listClick="sexShow = true" right>
      <a href="javascript:;" slot="right">{{ model.sex == 1 ? "男" : "女" }}</a>
    </edit-list>

    <div class="back">
      <p @click="$router.back()">返回个人中心</p>
    </div>

    <van-dialog
      v-model="show"
      title="修改昵称"
      show-cancel-button
      @confirm="confirmClick"
      @cancel="content = ''"
    >
      <van-field class="new_nicheng" v-model="content" autofocus />
    </van-dialog>

    <van-action-sheet
      v-model="sexShow"
      cancel-text="取消"
      :actions="actions"
      @select="onSelect"
    />
  </div>
</template>

<script>
import NavBar from "@/components/common/Navbar.vue";
import editList from "@/components/common/editList.vue";

export default {
  data() {
    return {
      model: {},
      show: false,
      content: "",
      sexShow: false,
      actions: [
        { name: "男", value: 1 },
        { name: "女", value: 2 }
      ]
    };
  },
  components: {
    NavBar,
    editList
  },
  methods: {
    async selectUser() {
      const res = await this.$http.get(
        "/home/api/user?id=" + localStorage.getItem("id")
      );
      this.model = res.data;
    },
    async afterRead(file) {
      const formdata = new FormData();
      formdata.append("file", file.file);
      const res = await this.$http.post("/home/api/upload", file);
      this.model.headimg = "https://www.shzmz.com/" + res.data.url;
      this.UserUpdate();
      setTimeout(() => {
        location.reload();
      }, 100);
    },
    async UserUpdate() {
      const res = await this.$http.post("/home/api/update", this.model);
      console.log(res);
    },
    confirmClick() {
      // console.log("确认修改");
      this.model.nickname = this.content;
      this.UserUpdate();
      this.content = "";
    },
    onSelect(data) {
      this.model.sex = data.value;
      this.UserUpdate();
      this.sexShow = false;
    }
  },
  created() {
    this.selectUser();
  }
};
</script>

<style scoped lang="scss">
.edit_form {
  margin-top: 48px;
}
.edit_form a {
  color: #333;
}
img.user_img {
  display: block;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  img {
    width: 100%;
    height: 100%;
  }
}
.upload_file {
  position: relative;
  overflow: hidden;
  .upload_img {
    position: absolute;
    opacity: 0;
  }
}
.back {
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
  padding: 10px 0;
  font-size: 14px;
  margin-top: 15px;
}
.new_nicheng {
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
</style>
